<template>
  <div>
    <el-dialog-zdy
      append-to-body
      title="学习进度  >  视频列表"
      :visible.sync="dialogVisible"
      width="50%"
      append-to-body
      :before-close="handleClose"
    >
      <div style="overflow:scroll;" :style="'height:'+bodyHeight+'px'">
        <el-table
          :data="dataList"
          :height="bodyHeight - 200"
          style="width: 100%">
          <el-table-column prop="resourcesName" label="视频名称"></el-table-column>
          <el-table-column prop="totalHours" label="总学习时长(分)"></el-table-column>
          <el-table-column prop="totalHoursLearned" label="已学时长(分)"></el-table-column>
          <!-- <el-table-column  label="操作">
            <template slot-scope="scope">
              <el-button size="mini" type="text" @click="detailRow(scope.row)">考试记录</el-button>
            </template>
          </el-table-column> -->

        </el-table>
      </div>


    </el-dialog-zdy>

    <record ref="record"></record>
  </div>

</template>


<script>
import  Record from '@/components/classTestRecord/record.vue'
export  default {
  components:{Record},
  props:{
    dataList:{
      type: Array,
      default:()=>{
        return []
      }
    },
    detailId:{
      type:String,
      default :()=>{
        return "";
      }
    },
    dialogVisible:{
      type: Boolean,
      default:()=>{
        return false
      }
    }
  },
  data(){
    return{
      bodyHeight: 300,
    }


  },
  methods:{
    handleClose(done){
      done()
      this.$emit("close")
    },
    detailRow(row){
      console.log('detailRow', row);
      // let dataFrom={
      //   trainingDetailListId:this.detailId,
      //   resourcesId: row.id || row.trainingResourcesId,
      //   trainingResourcesId: row.trainingResourcesId,
      // }
      // this.$refs.record.show(dataFrom,row.dataName);
      this.$router.push({
        path: '/student/lookExam?id='+row.paperId+'&examDetailListId='+row.examDetailId,
      })
    },
  },
  mounted() {
    this.bodyHeight = document.body.offsetHeight - 50;
  }
}

</script>



<style lang='scss' scoped>


</style>



// WEBPACK FOOTER //
// src/components/classTestRecord/courseware-video.vue